// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import RegistryPhysical from './RegistryPhysical';

export default compose(
    connect(
        state => ({
            user: state?.global?.user || [],
        }),
        dispatch => ({}),
    ),
)(RegistryPhysical);